import PopupManager from './PopupManager';
export const initPopup = () => {
    var _a;
    window.Popup = new PopupManager({
        disableScroll: true,
    });
    if (window.location.hash.indexOf('#popup') !== -1) {
        void ((_a = window.Popup) === null || _a === void 0 ? void 0 : _a.open(window.location.hash));
    }
};
initPopup();
// const renameAttribute = (el: HTMLElement, attrName: string, newAttrName: string) => {
//   if (el) {
//     const oldValue = el.getAttribute(attrName);
//     if (oldValue !== null) {
//       el.setAttribute(newAttrName, oldValue);
//       el.removeAttribute(attrName);
//     }
//   }
// };
// window.Popup.addEventListener('beforeOpen', () => {
//   document.querySelectorAll('[data-aos]').forEach((el) => {
//     renameAttribute(el as HTMLElement, 'data-aos', 'data-aos-disabled');
//   });
// });
// window.Popup.addEventListener('close', () => {
//   document.querySelectorAll('[data-aos-disabled]').forEach((el) => {
//     setTimeout(() => {
//       renameAttribute(el as HTMLElement, 'data-aos-disabled', 'data-aos');
//     }, 100);
//   });
// });
